import axios from 'axios';

// Base URL for all API calls (defaults to localhost if env var is missing)
export const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Unwrap envelope-style responses (backend returns { success:true, data: ... })
api.interceptors.response.use(
  (resp) => {
    if (resp && resp.data && resp.data.success && resp.data.hasOwnProperty('data')) {
      return { ...resp, data: resp.data.data };
    }
    return resp;
  },
  (err) => Promise.reject(err)
);

export default api;
